<template>
  <div class="tw-relative tw-flex tw-flex-col">
    <label :for="label"></label>
    <input
      type="text"
      class="tw-text-sm tw-rounded tw-p-4 focus:tw-border-primary"
      :class="{
        'tw-border-error': showError === true,
      }"
      v-model="username"
      @blur="$emit('validate', placeHolder)"
      :placeholder="placeHolder"
      required
    />
    <p class="tw-absolute tw--top-4 tw-right-px tw-text-error tw-text-xs">
      {{ errorMsg }}
    </p>
  </div>
</template>

<script>
export default {
  name: "OnboardingNameInput",

  emits: ["set", "validate"],

  props: {
    placeHolder: { type: String, default: () => "", required: true },
    label: { type: String, default: () => "", required: true },
    name: { type: String, default: () => "", required: true },
    error: { type: Object, default: () => {}, required: true },
    inputName: { type: String, default: () => "", required: true },
  },

  data() {
    return {
      showError: false,
      errorMsg: "",
    };
  },

  computed: {
    username:{
      get(){
        return this.name
      },
      set(value){
        this.$emit('set', { value, inputName: this.inputName })
      },
    }
  },

  methods: {
    checkError() {
      switch (this.error.$property) {
        case "firstName":
          this.showError = true;
          this.errorMsg = this.error.$message;
          break;

        case "lastName":
          this.showError = true;
          this.errorMsg = this.error.$message;
          break;

        case "name":
          this.showError = true;
          this.errorMsg = this.error.$message;
          break;

        case "industry":
          this.showError = true;
          this.errorMsg = this.error.$message;
          break;

        default:
          this.showError = false;
          this.errorMsg = "";
          break;
      }
    },
  },

  watch: {
    error(newValue, oldValue) {
      deep: true;
      immediate: true;
      if (newValue !== oldValue) {
        this.checkError();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
